export const BEND_FACTOR = 0.4;

export const ARROW_HEAD_LEFT_WING_SIZE = 30;
export const ARROW_HEAD_RIGHT_WING_SIZE = 35;
export const ARROW_HEAD_ANGLE = 60;
